'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResizeWatcher = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _resizeObserverPolyfill = require('resize-observer-polyfill');

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResizeWatcher = exports.ResizeWatcher = function (_React$PureComponent) {
    _inherits(ResizeWatcher, _React$PureComponent);

    function ResizeWatcher() {
        _classCallCheck(this, ResizeWatcher);

        var _this = _possibleConstructorReturn(this, (ResizeWatcher.__proto__ || Object.getPrototypeOf(ResizeWatcher)).apply(this, arguments));

        _this.observer = new _resizeObserverPolyfill2.default(_this.props.onResize);
        _this.containerRef = React.createRef();
        return _this;
    }

    _createClass(ResizeWatcher, [{
        key: 'render',
        value: function render() {
            return React.createElement("noscript", { ref: this.containerRef });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var container = this.containerRef.current;
            this.observer.observe(container.parentElement);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.observer.disconnect();
        }
    }]);

    return ResizeWatcher;
}(React.PureComponent);
//# sourceMappingURL=ResizeWatcher.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ResizeWatcher/ResizeWatcher.js